module.exports = __webpack_public_path__ + "Simple-Line-Icons.d2285965fe34b0546504.ttf";


//////////////////
// WEBPACK FOOTER
// /Users/bizqsoft/Documents/project/ibqs/ibqs-dip-2023-09-09/src/assets/fonts/simple-line-icons/Simple-Line-Icons.ttf?v=2.4.0
// module id = ../../../../../src/assets/fonts/simple-line-icons/Simple-Line-Icons.ttf?v=2.4.0
// module chunks = 40